<template>
  <div>
    <div class="m-field-group m-field-group--contain">
      <select
        name="year"
        id="year"
        v-model="selectedYear"
        @change="handleChange"
        :disabled="disabled"
      >
        <option :value="''">All Years (1995 onwards)</option>
        <option v-for="year in years" :key="year.year" :value="year.year">
          {{ year.label }}
        </option>
        <option value="2010">2006 - 2010</option>
        <option value="2005">2000 - 2005</option>
        <option value="1999">1995 - 1999</option>
      </select>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, defineExpose, ref, watch } from 'vue'
import _ from 'lodash'

const props = defineProps(['disabled'])
const emit = defineEmits(['change'])

const currentYear =
  new Date().getMonth() >= 5 ? new Date().getFullYear() : new Date().getFullYear() - 1

const years = ref([])
for (let i = currentYear; i >= 2011; i--) {
  years.value.push({
    year: i,
    label: `${i}/` + _.toString(i + 1).slice(-2),
  })
}

const selectedYear = ref(
  new Date().getMonth() >= 5 ? new Date().getFullYear() : new Date().getFullYear() - 1,
)

const setYear = (year) => {
  if (year === '') {
    selectedYear.value = ''
  } else if (year <= 2010) {
    if (year >= 2006 && year <= 2010) {
      selectedYear.value = 2010
    } else if (year >= 2000 && year <= 2005) {
      selectedYear.value = 2005
    } else if (year >= 1995 && year <= 1999) {
      selectedYear.value = 1999
    }
  } else {
    selectedYear.value = year
  }

  emit('change', selectedYear.value)
}

const handleChange = (event) => {
  const value = event.target.value
  setYear(value ? Number(value) : '')
}

defineExpose({
  setYear,
})
</script>
